import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { DownloadAppQRCode } from '@/components/DownloadAppQRCode';

type Props = Omit<
  React.ComponentProps<typeof DownloadAppQRCode>,
  'withDepopLogo'
>;

export function DownloadAppQRCodeSection({ size, ...qrCodeProps }: Props) {
  const t = useTranslations('common');

  return (
    <div className={styles.section}>
      <DownloadAppQRCode {...qrCodeProps} size={size} withDepopLogo />
      <Body
        variant="sm-bold"
        className={clsx(styles.title, {
          [styles['title--md']]: size === 'md',
        })}
      >
        {t('DownloadApp.QRTitle')}
      </Body>
      <Body variant="sm-regular">{t('DownloadApp.QRBody')}</Body>
    </div>
  );
}
